import { Button, Grid, Stack, TextField, Typography, Box, Alert } from "@mui/material";
import React from "react";
import { QRCode } from "react-qrcode-logo";
import Download from "@mui/icons-material/Download";
import { colorOptions } from "../../context/colorOptions";
import { logActivity } from "../../functions/axios";

export default function StaticQRGenerator(props) {
    
    let qrCodeRef = React.createRef();
    const [targetUrl, setTargetUrl] = React.useState(props.existingURL || "https://example.com");
    const [size, setSize] = React.useState(256);
    const sizeOptions = [
        [128, "S"],
        [256, "M"],
        [512, "L"],
    ];
    const [color, setColor] = React.useState(colorOptions[0]);


    const downloadQRCode = () => {
        const canvas = document.getElementById("qr-code");

        console.log(canvas);
        if (canvas) {
            console.log(qrCodeRef.current);

            const pngUrl = canvas.toDataURL("image/png").replace("image/png", "image/octet-stream");
            let downloadLink = document.createElement("a");
            downloadLink.href = pngUrl;
            downloadLink.download = "QRCode.png";
            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);

            // Log the download activity
            logActivity("static_qr_download");
        } else {
            console.error("No canvas found");
        }
    };
    return (
        <Box>
            <Typography variant="h5" gutterBottom>
                Static QR Code Generator
            </Typography>
            <Typography variant="body1" color="text.secondary" gutterBottom>
                Create a static QR code that links to a URL. This QR code is not trackable and cannot be changed once created.
            </Typography>
            <Grid container spacing={2}>
                <Grid item sm={6} xs={12}>
                    <Stack direction={"column"} spacing={1}>
                        {!props.existingURL && <TextField
                            label="URL"
                            value={targetUrl}
                            onChange={(e) => setTargetUrl(e.target.value)}
                            fullWidth
                        />}
                        <Typography variant={"h6"}>Select size</Typography>
                        <Stack direction={"row"} spacing={2}>
                            {sizeOptions.map(([sizeOption, label]) => (
                                <Button
                                    key={label}
                                    onClick={() => setSize(sizeOption)}
                                    variant="contained"
                                    color={sizeOption === size ? "secondary" : "primary"}
                                    // sx={{ width: "64px" }}
                                >
                                    {label}
                                </Button>
                            ))}
                            <TextField
                                size="small"
                                label="Size"
                                value={size}
                                onChange={(e) => setSize(e.target.value)}
                                fullWidth
                                type="number"
                                inputProps={{ min: 0, stepSize: 50 }}
                                sx={{ width: "100px" }}
                            />
                        </Stack>
                        {(size < sizeOptions[1][0] || targetUrl.length > size) && (
                            <Alert severity="warning">
                                The size may be too small for the QR code to be readable. 
                                Check readibility on the QR code preview using an appropriate device.
                            </Alert>
                        )}
                        <Typography variant={"h6"}>Select color</Typography>
                        <Stack direction={"row"} spacing={2}>
                            {colorOptions.map((option, index) => (
                                <Button
                                    key={index}
                                    onClick={() => setColor(option)}
                                    variant="contained"
                                    color={option.name === color.name ? "secondary" : "primary"}
                                >
                                    {option.name}
                                </Button>
                            ))}
                        </Stack>
                        {}
                    </Stack>
                </Grid>
                <Grid item container sm={6} xs={12}>
                    <Grid item xs={12}>
                        <QRCode
                            id={"qr-code"}
                            ecLevel={"H"}
                            value={targetUrl}
                            ref={qrCodeRef}
                            size={size}
                            logoImage={false}
                            logoWidth={size / 4}
                            qrStyle={'square'}
                            fgColor={color.fgcolor}
                            bgColor={color.bgcolor}
                        />
                    </Grid>
                    <Grid item>
                        <Typography>
                            Link: <a href={targetUrl} target="_blank" rel="noopener noreferrer">{targetUrl}</a>
                        </Typography>
                        <Button startIcon={<Download />} onClick={downloadQRCode} variant="contained">
                            Download QR code
                        </Button>
                    </Grid>
                </Grid>
            </Grid>
        </Box>
    );
}
